import { DateFormat, userConfigStore } from "@/store/user-config-store";
import { parseApiDateOnly } from "./date-input";

interface Options {
  dateOnly?: boolean;
}

function buildDateString(date: Date, dateFormat: DateFormat): string {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear());

  switch (dateFormat) {
    case DateFormat.EuropeanSlash:
      return `${day}/${month}/${year}`;
    case DateFormat.US:
      return `${month}/${day}/${year}`;
    case DateFormat.ISO:
      return `${year}-${month}-${day}`;
    case DateFormat.EuropeanDot:
    default:
      return `${day}.${month}.${year}`;
  }
}

function buildTimeString(date: Date): string {
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
}

export function formatDateToLocale(date: string, options: Options = {}) {
  const { dateOnly } = options;

  const formattedDate = new Date(date);
  const { dateFormat } = userConfigStore.getState();

  const datePart = buildDateString(formattedDate, dateFormat);

  if (dateOnly) {
    return datePart;
  }

  return `${datePart} ${buildTimeString(formattedDate)}`;
}

export function formatApiDateOnlyToLocale(date?: string | null): string | undefined {
  const parsed = parseApiDateOnly(date);
  if (!parsed) return undefined;

  return buildDateString(parsed, userConfigStore.getState().dateFormat);
}

export function formatDateToApi(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function formatLocalDateToUtcIso(date: Date): string {
  return `${formatDateToApi(date)}T00:00:00.000Z`;
}

export { buildDateString, buildTimeString };
